window.callModal = function (data) {
    $(data).modal('toggle');
}